<template>
  <div id="app" class="ui container">
    <vuetable
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :data-total="dataCount"
      :data-manager="dataManager"
      pagination-path="pagination"
      :per-page="10"
      :css="css.table"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:cell-clicked="onCellClick"
      :sort-order="sortOrder"
      :key="refreshKey+10"
    />
    <vuetable-pagination
      ref="pagination"
      class="pull-right"
      @vuetable-pagination:change-page="onChangePage"
      :key="refreshKey"
    />
  </div>
</template>

<script>
import _ from "lodash";
import Vuetable from "vuetable-2";
import VuetablePagination from "./VuetablePagination";
import VuetableCssConfig from "./VuetableCssConfig";

export default {
  props: {
    fields: {
      type: Array,
      required: true
    },
    localData: {
      type: Array,
      required: true
    },
    onCellClick: {
      type: Function,
      default: () => {}
    },
    sortOrder: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    Vuetable,
    VuetablePagination
  },
  data() {
    return {
      css: VuetableCssConfig,
      dataCount: 0,
      searchFor: "",
      refreshKey: 0
    };
  },
  watch: {
    localData(newVal, oldVal) {
      this.refreshKey++;
    }
  },
  mounted() {
    this.$refs.vuetable.setData(this.localData);
    this.$refs.vuetable.refresh();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let data = this.localData;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        data = _.orderBy(data, sortOrder[0].sortField, sortOrder[0].direction);
      }

      // since the filter might affect the total number of records
      // we can ask Vuetable to recalculate the pagination for us
      // by calling makePagination(). this will make VuetablePagination
      // work just like in API mode
      pagination = this.$refs.vuetable.makePagination(data.length);

      // if you don't want to use pagination component, you can just
      // return the data array
      return {
        pagination: pagination,
        data: _.slice(data, pagination.from - 1, pagination.to)
      };
    }
  }
};
</script>

<style scoped>
.container {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  font-size: var(--vw14px);
}
</style>
